const routes = {
    LOGIN: "/login",
    LOGIN_WITH_SSO: "/loginWithSso",
    SELECT_SITE: "/select",
    CAPTURE_PHOTO: "/capture-photo"
}

export default routes
